module.exports = __webpack_public_path__ + "media/static/flags/pt-2780f259dfe9c2199a19446548da51e6.svg";